import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { KingService } from '../king.service';
import { LevelBarComponent } from '../../../core/components/level-bar/level-bar.component';
@Component({
  selector: 'app-king-timer',
  templateUrl: './king-timer.component.html',
  styleUrls: ['./king-timer.component.scss'],
  imports: [LevelBarComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingTimerComponent {
  public readonly kingService = inject(KingService);
}
